import React from 'react'
import List from 'containers/gxps/List'
import {withRouter} from 'react-router-dom'

const OwnedGxps = props =>
  <List {...props} pageSize={10} filter={{owner: props.match.params.id}}/>

export default withRouter(OwnedGxps)